import { selectIsSerie } from 'containers/Player/selectors/media.selector';
import { store } from 'store';

export const isItTheLastEpisodeAndTheLastSeason = () => {
    try {
        const { Player } = store?.getState() || {};

        const lastData = Player?.Series?.dataSeriesLastEpisodeAndseason;
        const dataCurrent = Player?.Content?.data?.group?.common?.extendedcommon?.media?.episode
        const currentEpisode = dataCurrent?.number;
        const currentSeason = dataCurrent?.season;
    
        const currenEpisodeInt = parseInt(currentEpisode);
        const CurrentSeasonInt =  parseInt(currentSeason);
    
        const lastEpisodeInt =  parseInt(lastData?.last_episode);
        const lastSeasonInt = parseInt(lastData?.last_season);
    
        if(CurrentSeasonInt === lastSeasonInt & currenEpisodeInt === lastEpisodeInt ) return true;
        return false;
    } catch (error) {
        console.log('Error en funcion ItIsTheLastSeasonAndTheLastEpisode', error)
        return false;
    }
}


export const getLastEpisode = (seasonsSerie)=> {
    try {
        const lastSeason = seasonsSerie?.length -1;
        const lastEpisode = seasonsSerie?.[lastSeason]?.episodes_count;
        return lastEpisode;
    } catch (error) {
        return null;
    }
}


export const isNotThisTheEndOfTheSeries = ()=> {
    const isSerie = selectIsSerie(store?.getState())
    if(isSerie){
      return !isItTheLastEpisodeAndTheLastSeason();
    }
    return isSerie;
  }